/****
 * Tabs Content 管理tabs list状态
 */
function observes(obj) {
    const proxy = new Proxy(obj, {
        get(target, k) {
            let v = target[k];
            console.log(k, '读取');
            return v;
        },
        set(target, k, val) {
            if (target[k] !== val) {
                target[k] = val;
                console.log(k, '更改');
            }
        }
    });
    return proxy;
}
// const proxy = observe(obj);
// proxy.name = 'proxy';